<template>
  <div>
    <nav class="navbar jobDetNav navbar-expand-xl navbar-expand-lg navbar-fixed-top">
      <button
        class="navbar-toggler toggler-example"
        id="togglebutton"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent1"
        aria-controls="navbarSupportedContent1"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="dark-blue-text">
          <img src="../assets/HamburgrMenu.svg" class="mt-3" alt="hamburger"/>
        </span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent1">
        <div class="heightcontainer">
          <div class="sidebar-background sidebar-background1">
            <div class="col-3">
              <div class="row">
                <div class="ml-5 mt-sm-1 mt-md-1 mt-lg-4">
                  <div class=" d-flex justify-content-between profilesummery pr-0 pl-0">
                    <button class="postjobbtn backgroundcolorblack borderradius20 mouseoverbtn2 d-flex justify-content-center white my-auto" :class="{'backgroundcolor3' :activePostajobBtn}" @click="NavToPostaJob">
                      <img src="../assets/Post_a_Job_active.svg" v-if="activePostajobBtn" class="img-fluid" alt="active">
                      <img src="../assets/Post_a_Job_inactive.svg" v-else class="img-fluid" alt="inactive">
                      <span class="ml-3 fontsize16 proximanova stylebold">Post a Free Job</span>
                    </button>
                    <div class="backgroundcolorblack white closebtndobDet pointer" data-toggle="collapse"
                        data-target="#navbarSupportedContent1"
                        aria-controls="navbarSupportedContent1"
                        aria-expanded="false" @click="closeJobDetailsSideMenu">x</div>
                  </div>
                  <div class="borderbottom mt-4"></div>
                  <div class="col d-flex mt-2" id="people" 
                  :class="{'active': (selectElement=== 'postedjobs' && currentRoute === 'postedjobs')}"
                  @mouseover="mouseover_posted" @mouseleave="mouseleave_posted" @click="NavToPostedJobList('postedjobs')">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex">
                        <img :src="postedSvg" class="img-fluid mr-2 " id="icon-img" alt="posted"/>
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 sidemenuItem proximanova">Manage Jobs</label>
                        </div>
                    </div>
                  </div>
                  <!-- <div class="col d-flex" id="people"
                  @mouseover="mouseover_saved" @mouseleave="mouseleave_saved">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex" >
                        <img :src="savedSvg" class="img-fluid mr-2" id="icon-img"/>
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 sidemenuItem ">Saved</label>
                        </div>
                    </div>
                  </div> -->
                  <div class="col d-flex" id="people" @mouseover="mouseover_draft" @mouseleave="mouseleave_draft" @click="routetoDraftJobspage()">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex" >                     
                        <img :src="draftSvg" class="img-fluid mr-2 "  id="icon-img" alt="draft"/>
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 sidemenuItem proximanova">Draft</label>
                        </div>                   
                    </div>
                  </div>
                  <div class="col d-flex" id="people" @mouseover="mouseover_closed" @mouseleave="mouseleave_closed" @click="routetoClosedJobspage()">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex" >                     
                        <img :src="closedSvg" class="img-fluid mr-2 "  id="icon-img" alt="closed"/>
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 sidemenuItem proximanova">Closed</label>
                        </div>                   
                    </div>
                  </div>
                  <div class="col d-flex" id="people" @mouseover="mouseover_deleted" @mouseleave="mouseleave_deleted" @click="routetoDeletedJobspage()">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex" >                     
                        <img :src="deletedSvg" class="img-fluid mr-2 "  id="icon-img" alt="deleted"/>
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 sidemenuItem proximanova">Deleted</label>
                        </div>                   
                    </div>
                  </div>
                  <div class="col d-flex mt-2 mt-md-0" id="people" @click="routetoFindResumespage()"
                  :class="{'active': currentRoute === 'findResumes'}" @mouseover="mouseover_findresume" @mouseleave="mouseleave_findresume">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex" >                     
                        <img :src="findresumeSvg" class="img-fluid mr-2 "  id="icon-img" alt="deleted"/>
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 sidemenuItem proximanova">Find Resume</label>
                        </div>                   
                    </div>
                  </div>
                  <!-- <div class="col d-flex" id="people" @mouseover="mouseover_history" @mouseleave="mouseleave_history">
                    <div class="pl-1 mt-sm-3 mt-md-3 mt-lg-4 d-flex" >                     
                        <img :src="historySvg" class="img-fluid mr-2 "  id="icon-img" />
                        <div class="listitemname">
                          <label class="bold ml-2 p-1 sidemenuItem ">History</label>
                        </div>                   
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import BottomFooter from "@/components/BottomFooter.vue";
import httpbusiness from "@/js/http-business.js";
import { bus } from "../main";
import router from '../router';
import sessionUtils from "@/js/session-util.js";
export default {
  components: {
  },

  data() {
    return {
      companyprofileId : null,
      businessAccountId : null,
      companyDetails : {},
      profilePictureLink : '',
      firstName : '',
      lastName :'',
      fullName : '',
      designation : '',
      currentRoute : '',
      selectElement: '',
      //initial svg icons
      activePostajobBtn : false,
      postedSvg : require('../assets/SidemenuPosted.svg'),
      savedSvg : require('../assets/SidemenuSaved.svg'),
      draftSvg : require('../assets/SidemenuDraft.svg'),
      closedSvg : require('../assets/SidemenuClosed.svg'),
      deletedSvg : require('../assets/SidemenuDeleted.svg'),
      historySvg : require('../assets/SidemenuHistory.svg'),
      peopleSvg: null,
      jobSvg: require('../assets/Job.svg'),
      deleteSvg : require('../assets/Delete_sidmenu_icon.svg'),
      findresumeSvg : require('../assets/Find_resumes.svg'),
      homeSvg: null,
      //hide and display sidemenu for lg
      sidemenujobDet : null,
    };
  },
  components: {
  },
  methods: {
    fetchdata() {
      this.fetchCompanyData()
    },
    closeJobDetailsSideMenu(){
        bus.$emit('closeSideMenuJobDet', 'close')
    },
    fetchCompanyData() {
      httpbusiness.get('/business/getcompanyProfileData?businessAccountId='+this.businessAccountId)
      .then((response) => {
        console.log(response)
        this.companyDetails = response.data
      }).catch((e) => {
        console.log(e)
      })
    },
    NavToPostaJob(){
      this.activePostajobBtn = true;
      router.push({
        name : 'postajob'
      })
    },
    NavToPostedJobList(elementId){
      this.$session.set("selectElement", 'postedjobs')
      this.selectElement = elementId
       this.$router.push({
          name : 'postedJobs'
        })
        bus.$emit('refreshPostedJobsList', true)
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    routetoDraftJobspage: function () {
       this.$router.push({
          name : 'draftJobs'
        })
        bus.$emit('refreshDraftJobsList', true)
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    routetoDeletedJobspage: function () {
       this.$router.push({
          name : 'createdJobs'
        })
        bus.$emit('refreshDeletedJobsList', true)
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }      
    },
    routetoClosedJobspage : function() {
       this.$router.push({
          name : 'closedJobs'
        })
        bus.$emit('refreshClosedJobsList', true)
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    routetoJobpage : function() {
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    routetosuggestedpage:function(element){
      if(this.companyprofileId !== null & this.companyprofileId !== undefined) {        
        this.$session.set("selectElement", 'people')        
        this.$router.push({
          name : 'People'
        })
      }
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    routetoFindResumespage : function() {
      this.$router.push({
          name : 'findResumes'
        })
        bus.$emit('refreshFindResumesList', true)
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    //mouseover interactions
    mouseover_posted(){
      this.postedSvg = require('../assets/SidemenuPostedBlue.svg')
    },
    mouseleave_posted(){
      if(this.selectElement !== 'postedjobs'){
        this.postedSvg = require('../assets/SidemenuPosted.svg')
      }
    },
    mouseover_saved(){
      this.savedSvg = require('../assets/SidemenuSavedBlue.svg')
    },
    mouseleave_saved(){
      this.savedSvg = require('../assets/SidemenuSaved.svg')
    },
    mouseover_draft(){
      this.draftSvg = require('../assets/SidemenuDraftBlue.svg')
    },
    mouseleave_draft(){
      this.draftSvg = require('../assets/SidemenuDraft.svg')
    },
    mouseover_closed(){
      this.closedSvg = require('../assets/SidemenuClosedBlue.svg')
    },
    mouseleave_closed(){
      this.closedSvg = require('../assets/SidemenuClosed.svg')
    },
    mouseover_deleted(){
      this.deletedSvg = require('../assets/SidemenuDeletedBlue.svg')
    },
    mouseleave_deleted(){
      this.deletedSvg = require('../assets/SidemenuDeleted.svg')
    },
    mouseover_history(){
      this.historySvg = require('../assets/SidemenuHistoryBlue.svg')
    },
    mouseleave_history(){
      this.historySvg = require('../assets/SidemenuHistory.svg')
    },
    mouseover_findresume() {
      this.findresumeSvg = require('../assets/Find_resumes_blue.svg')
    },
    mouseleave_findresume(){
      this.findresumeSvg = require('../assets/Find_resumes.svg')
    },
    openMainPage(){
       this.$router.push({
          name : 'welcome'
        })
      if(screen.width < 900) {
        let backbtn = document.getElementById('hamburgerbackbtnclick')
        if(backbtn) {
          backbtn.click()
        }    
      }
    },
    highlightCurrentRoute(){
      if(this.currentRoute === 'postedJobs' ){ 
        this.postedSvg = require('../assets/SidemenuPostedBlue.svg')
        this.savedSvg = require('../assets/SidemenuSaved.svg')
        this.deletedSvg = require('../assets/SidemenuDeleted.svg')
        this.closedSvg = require('../assets/SidemenuClosed.svg')
        this.draftSvg = require('../assets/SidemenuDraft.svg')
        this.historySvg = require('../assets/SidemenuHistory.svg')
        this.findresumeSvg = require('../assets/Find_resumes.svg')
      } else if(this.currentRoute === 'savedJobs' ){ 
        this.postedSvg = require('../assets/SidemenuPosted.svg')
        this.savedSvg = require('../assets/SidemenuSavedBlue.svg')
        this.deletedSvg = require('../assets/SidemenuDeleted.svg')
        this.closedSvg = require('../assets/SidemenuClosed.svg')
        this.draftSvg = require('../assets/SidemenuDraft.svg')
        this.historySvg = require('../assets/SidemenuHistory.svg')
        this.findresumeSvg = require('../assets/Find_resumes.svg')
      }else if(this.currentRoute ==='createdJobs'){  
        this.postedSvg = require('../assets/SidemenuPosted.svg')     
        this.savedSvg = require('../assets/SidemenuSaved.svg')        
        this.deletedSvg = require('../assets/SidemenuDeletedBlue.svg')
        this.closedSvg = require('../assets/SidemenuClosed.svg')
        this.draftSvg = require('../assets/SidemenuDraft.svg')
        this.historySvg = require('../assets/SidemenuHistory.svg')
        this.findresumeSvg = require('../assets/Find_resumes.svg')
      }else if(this.currentRoute ==='closedJobs'){
        this.savedSvg = require('../assets/SidemenuSaved.svg')
        this.postedSvg = require('../assets/SidemenuPosted.svg')  
        this.deletedSvg = require('../assets/SidemenuDeleted.svg')
        this.closedSvg = require('../assets/SidemenuClosedBlue.svg')
        this.draftSvg = require('../assets/SidemenuDraft.svg')
        this.historySvg = require('../assets/SidemenuHistory.svg')
        this.findresumeSvg = require('../assets/Find_resumes.svg')
      }else if(this.currentRoute ==='draftJobs'){
        this.savedSvg = require('../assets/SidemenuSaved.svg')
        this.postedSvg = require('../assets/SidemenuPosted.svg')  
        this.deletedSvg = require('../assets/SidemenuDeleted.svg')
        this.closedSvg = require('../assets/SidemenuClosed.svg')
        this.draftSvg = require('../assets/SidemenuDraftBlue.svg')
        this.historySvg = require('../assets/SidemenuHistory.svg')
        this.findresumeSvg = require('../assets/Find_resumes.svg')
      }else if(this.currentRoute === 'findResumes'){
        this.savedSvg = require('../assets/SidemenuSaved.svg')
        this.postedSvg = require('../assets/SidemenuPosted.svg')  
        this.deletedSvg = require('../assets/SidemenuDeleted.svg')
        this.closedSvg = require('../assets/SidemenuClosed.svg')
        this.draftSvg = require('../assets/SidemenuDraft.svg')
        this.historySvg = require('../assets/SidemenuHistory.svg')
        this.findresumeSvg = require('../assets/Find_resumes_blue.svg')
      }else{
        this.postedSvg = require('../assets/SidemenuPosted.svg')  
        this.savedSvg = require('../assets/SidemenuSaved.svg')
        this.deletedSvg = require('../assets/SidemenuDeleted.svg')
        this.closedSvg = require('../assets/SidemenuClosed.svg')
        this.draftSvg = require('../assets/SidemenuDraft.svg')
        this.historySvg = require('../assets/SidemenuHistory.svg')
        this.findresumeSvg = require('../assets/Find_resumes.svg')
      }
    },
  },
 watch: {
   '$route': function (from, to) {
     this.currentRoute = this.$router.currentRoute.name;
     this.highlightCurrentRoute()
   }
 },
  
  created() {    
    this.currentRoute = this.$router.currentRoute.name;
    this.businessAccountId = sessionUtils.getBusinessAccountId();
    this.companyprofileId = sessionUtils.getCompanyProfileId();
    this.highlightCurrentRoute()
    this.fetchdata();
    //updating profile picture
    bus.$on('updatingCompanyLogoLink', (data) => {
      if(data){
        this.companyDetails.companyLogoLink = data;
      }
    })
    bus.$on('openToggleMenu', (data) => {
      if(data){
        this.sidemenujobDet = data
        document.getElementById('togglebutton').click()
      }
    }) 
  }, 
};
</script>
<style scoped>
.navbar {
  padding: 0px 0px 0px 0px !important;
  position: fixed;
  background-color: #ffffff;
  z-index: 1;
}
.sidebar-backgroundheader {
  background-color: #ffffff;
}
.heightcontainer {
    width: 350px !important;
}
.navbar{
  z-index: 100;
}
.jobDetNav{
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    margin-top: 20px;
}
.closebtndobDet{
    width: 27px;
    height: 27px;
    text-align: center;
    border-radius: 50%;
    /* padding: 0 2px 2px 8px; */
}
.profilesummery {
  border-radius: 10px;
  width: 280px;
}
.postjobbtn{
  width: 200px;
  border: none;
  padding: 10px;
  border-radius: 10px;
}
.profiledet {
  padding-left: 0px;
  padding-right: 10px;
}
.profile-border{
  padding: 1.5px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.pdtext {
  font-size: 12px;
  padding: 0 1em 1em 0;
  text-align: center;
}
.listitemname {
  margin-top: -4px;
}
#icon-img{
  width: 20px;
  height: 20px;
}
.active{
  background-color: rgba(161, 166, 179,0.06);
   color: #007AFF !important;
   cursor: pointer;
}
#people:hover{
   background-color: rgba(161, 166, 179,0.06);
   border-radius: 10px;
   color: #007AFF !important;
   cursor: pointer;
}

#people:active{
  border: 2px solid #007AFF;  
  background-color: #d6e9ff;
  border-radius: 10px;
}
a {
  color:black;
}
#people a:hover{
  color: blue
}
.hover{
  cursor: pointer;
}
#nameBlock:hover{
color:#007AFF;
white-space: nowrap;
}
  .fullName{
    white-space: nowrap;
  }
  #people::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
	background-color :  rgba(161, 166, 179,0.06);
  
  }
 
  #people:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1;
  border-radius: 10px;
  border: 1px solid red;
  }
.nav-height {
  margin-top: 2px;
  border-bottom: 2px solid rgba(219, 219, 219,1);
}
@media (max-width: 600px) {
  label {
    font-size: 13px;
  }
  .navbar {
    padding: 0px 0px 0px 0px !important;
    position: fixed;
    background-color: #ffffff;
    width: 0% !important;
    z-index: 1;
  }
  .nav-height {
    border-bottom: none;
  }
}
@media (min-width: 900px) {
  .sidebar-background1 {
    background-color: white !important;
  }
}
@media (max-width: 900px) {
  label {
    font-size: 13px;
  }
  .sidebar-backgroundheader {
    background-color: #f0f2f5;
  }
  .navbar-collapse {
    position: fixed;
    top: 0px;
    left: 0;
    /* padding-left: 15px; */
    padding-right: 15px;
    padding-bottom: 15px;
    width: 62%;
    height: 100%;
  }

  .navbar-collapse.collapsing {
    left: -75%;
    transition: height 0s ease;
  }
  .nav-height {
    border-bottom: none;
  }
  .navbar-collapse.show {
    left: 0;
    transition: left 300ms ease-in-out;
  }

  .navbar-toggler.collapsed ~ .navbar-collapse {
    transition: left 500ms ease-in-out;
  }
}
@media (min-width: 900px) {
    .navbar-collapse {
    
    left: 0;
    padding-right: 15px;
    padding-bottom: 15px;
    width: 62%;
    height: 100%;
  }

  .navbar-collapse.collapsing {
    left: -75%;
    transition: height 0s ease;
  }
  .nav-height {
    border-bottom: none;
  }
  .navbar-collapse.show {
    left: 0;
    transition: left 300ms ease-in-out;
  }

  .navbar-toggler.collapsed ~ .navbar-collapse {
    transition: left 500ms ease-in-out;
  }
}
@media (max-width: 430px) {
  .navbar {
    padding: 0px 0px 0px 0px !important;
    position: fixed;
    background-color: #ffffff;
    width: 0% !important;
    z-index: 1;
  }
  .navbar-collapse {
    position: fixed;
    top: 0px;
    left: 0;
    /* padding-left: 15px; */
    padding-right: 15px;
    padding-bottom: 15px;
    width: 100%;
    height: 100%;
  }
}
</style>
